import { get } from 'lodash';

export const hasPinConfigured = state => {
  const statusControlPin = state.cvEpg.channelBlocker.statusControlPin.data;
  if (!statusControlPin) {
    return null;
  }
  return (
    statusControlPin.pin_purchase.status === 1 ||
    statusControlPin.pin_parental.status === 1 ||
    statusControlPin.pin_channel.status === 1
  );
};

export const hasPinChannelActive = state => {
  const statusControlPin = state.cvEpg.channelBlocker.statusControlPin.data;
  if (!statusControlPin) {
    return null;
  }
  return statusControlPin.pin_channel.status === 1;
};

export const isAbletoBlock = state => {
  const channelsBlocked = get(
    state,
    'cvEpg.channelBlocker.statusControlPin.data.pin_channel.info',
    [],
  );
  const canPlay = state?.linealChannel?.data;
  const epgChannels = state?.Player?.EpgChannels?.data;
  const channelsGroupIdList = epgChannels?.map(channel => channel?.group_id);
  const channelsCanPlayList = Object?.keys(canPlay || [])?.sort();
  const channelsAble = channelsGroupIdList?.filter(groupId =>
    canPlay?.[groupId]?.live?.canPlay === 1,
  );
  const channelsAbleToBlock = channelsBlocked?.filter(groupId =>
    canPlay?.[groupId]?.live?.canPlay === 1,
  );
  const channelsThatCanBeBlocked =
    channelsAble?.length - channelsAbleToBlock?.length;
  return channelsThatCanBeBlocked > 1;
};
